import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { ConfigurationService } from "@common/services";
import { IConfigTranslate } from "@core/models/translate";
import { TranslateRequest } from "@core/models/translate-request";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MSTranslationService{

    private currentConfigSubject: BehaviorSubject<IConfigTranslate>;

    /**
     * 
     * @param _http client
     */
    constructor(private _http: HttpClient) 
    {
        this.currentConfigSubject = new BehaviorSubject(null);
    }


    // getter: currentUserValue
    public get currentConfigValue(): IConfigTranslate {
        return this.currentConfigSubject.value;
    }

    // getter: event current user value changed
    public get onCurrentConfigChanged(): Observable<IConfigTranslate> {
        return this.currentConfigSubject.asObservable();
    }

    /**
     * Registra la configuración inicial del traductor
     * @param {IConfigTranslate} config
     */
    register(config: IConfigTranslate): void{
        this.currentConfigSubject.next(config);
    }


    /**
     * return the translation's text
     * @param text text to be translated
     * @param fromLanguage source language code
     * @param toLanguage target language code
     * @returns 
     */
    async getTranslation(text: string,fromLanguage: string ="",toLanguage: string =""){

        // Validating empty request
        if(text == '' || text == null)
            return; 

        // Crea el objeto de solicitud
        const request: TranslateRequest = {
            originLanguage: fromLanguage == "" ? "es" : fromLanguage,
            targetLanguage: toLanguage == "" ? "en" : toLanguage,
            text: text
        };

        // request to API
        return this._http.post<string>(`${environment.azureApiUrl}/api/azure-translate`, request, {responseType:'text' as 'json'}).toPromise();

    }

    /**
     * Detecta el idioma del texto y lo traduce al inglés o español
     * @param {string} text Indica el texto a traducir
     * @returns {Observable<TranslateRequest>} Observable con la petición de traducción
     */
    detectAndTranslate(text: string): Observable<TranslateRequest> {
        
        // Validating empty request
        if(text == '' || text == null)
            return;

        // Crea el objeto de solicitud
        const request: TranslateRequest = { text: text };

        // request to API
        return this._http.post<TranslateRequest>(`${environment.azureApiUrl}/api/azure-translate/detect`, request);
    }

}
